import { createSelector } from 'reselect'
import { PostingRootState } from '../postingRoot.reducer'

export const getTheme = createSelector(
  (state: PostingRootState) => state.commonStore.theme,
  (state) => state,
)

export const getUser = createSelector(
  (state: PostingRootState) => state.commonStore.user,
  (state) => state,
)

export const getPostingConfiguration = createSelector(
  (state: PostingRootState) => state.commonStore.postingConfiguration,
  (state) => state,
)

export const getGeneralPostingOptions = createSelector(
  (state: PostingRootState) => state.commonStore.generalPostingOptions,
  (state) => state,
)

export const getSocialMediaNetworks = createSelector(
  (state: PostingRootState) => state.commonStore.socialMediaNetworks,
  (state) => state,
)

export const namedRequestInProgress = createSelector(
  [
    (state: PostingRootState) => state.commonStore.requests,
    (state: PostingRootState, type: string) => type,
  ],
  (state, type) => {
    return state.filter(request => request.type === type && request.inProgress).length > 0
  },
)

export const getAboTopics = createSelector(
  (state: PostingRootState) => state.commonStore.aboTopics,
  (state) => state,
)

export const namedRequestStatus = createSelector(
  [
    (state: PostingRootState) => state.commonStore.requests,
    (state: PostingRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)?.status
  },
)

export const namedRequestData = createSelector(
  [
    (state: PostingRootState) => state.commonStore.requests,
    (state: PostingRootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)
  },
)
